<template>
    <div
        class="gcmcn-card taker-group-card"
        :class="{'selected-element' : selectedTakerGroupUid === takerGroup.uid}"
        @click="selectTakerGroup"
    >
        <div>{{ takerGroup.name }}</div>

        <i
            class="el-icon-arrow-right selection-arrow"
            :class="{'rotate-icon-arrow' : selectedTakerGroupUid === takerGroup.uid}"
        ></i>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        takerGroup: {
            type: Object,
            required: true,
        },
        selectedTakerGroupUid: {
            type: String,
            required: true,
        }
    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        selectTakerGroup (){
            this.$emit('on-select-taker-group', this.takerGroup);
        },
    },
};
</script>

<style lang="scss">
.taker-group-card{
    display: flex;
    position: relative;
    cursor: pointer;
    .taker-group-name{
        font-weight: bold;
    }
    & + .taker-group-card {
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/RightGroup/taker-group.vue